export const SOCIAL_LINK = {
  APPLE : 'https://iforgot.apple.com/password/verify/appleid' ,
  GOOGLE: 'https://accounts.google.com/signin/v2/recoveryidentifier?flowName=GlifWebSignIn&flowEntry=AccountRecovery',
  NAVER_ID: 'https://nid.naver.com/user2/help/idInquiry.nhn?menu=idinquiry',
  NAVER_PW: 'https://nid.naver.com/user2/help/pwInquiry.nhn?menu=pwinquiry',
  KAKAO_ID: 'https://accounts.kakao.com/weblogin/find_account_guide?continue=https%3A%2F%2Faccounts.kakao.com%2Fweblogin%2Faccount%2Finfo',
  KAKAO_PW: 'https://accounts.kakao.com/weblogin/find_password?continue=https%3A%2F%2Faccounts.kakao.com%2Fweblogin%2Faccount%2Finfo',
};